import { render, staticRenderFns } from "./RedditiPatrimonioTable.vue?vue&type=template&id=34a7c4ac&"
import script from "./RedditiPatrimonioTable.vue?vue&type=script&lang=js&"
export * from "./RedditiPatrimonioTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RedditiPatrimonioTable.vue"
export default component.exports